module.exports = __webpack_public_path__ + "static/media/sx.215fd417.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sx.svg
// module id = 2217
// module chunks = 0